module.exports = __webpack_public_path__ + "img/30.7074cd99.png";